import React from 'react'

function Masthead() {
  return (
    <section className="masthead -type-4 relative w-full h-full py-12 md:py-16 lg:py-24 bg-light-5">
      <div className="container mx-auto max-w-[1530px] px-6 sm:px-8 h-full">
        <div className="flex flex-col lg:flex-row items-center h-full gap-12">
          {/* Partie image - affichée en premier sur mobile */}
          <div id='image-container' className="w-full lg:w-6/12 h-full order-first lg:order-last">
            <div className="">
              <img
                src="/IROKO_IMAGE/jeune-garcon-apprenant-plus-sur-la-chimie-en-classe.jpg"
                alt="Illustration"
                className="w-full max-w-full h-full"
              />
            </div>
          </div>

          {/* Partie texte - affichée en second sur mobile */}
          <div className="w-full ml-0 lg:w-5/12 order-last lg:order-first">
            <h1 className="text-title font-bold leading-tight text-dark-1 dark:text-white">
              Apprends. Fabrique.<br />
              Innove. <br /> <span className="text-blue-1 underline">Avec les meilleurs.</span>
            </h1>

            <p className="text-light-1 dark:text-gray-300 text-normal mt-6 mb-8">
              GoNextMaker est l'école des Makers du futur, un écosystème où chaque apprenant
              qu'il soit lycéen, étudiant, passionné ou professionnel
              suit un parcours progressif, pratique et certifiant avec des tuteurs .
            </p>

            <div className="flex flex-wrap gap-3 sm:gap-5 mt-8">
              <a href="/little-maker" className="button bg-red-4 border-2 hover:bg-transparent text-white text-button
                font-medium py-3 px-6 sm:px-8 rounded-full hover:border-red-4 transition-colors hover:text-red-4">
                Découvrir nos parcours Little Maker (10-17 ans)
              </a>
              <a href="/bootcamp" className="text-button button border-2 border-blue-1 dark:border-gray-300 hover:bg-blue-1 dark:hover:bg-gray-300
                text-blue-1 dark:text-gray-300 hover:text-white dark:hover:text-blue-1 font-medium py-3 px-6 sm:px-8 rounded-full transition-colors">
                Explorer nos Bootcamps (18+)
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Masthead